import React from "react";
import { FiImage, FiPlus, FiTrendingUp } from "react-icons/fi";
import { GiLargePaintBrush } from "react-icons/gi";

import AdminButton from "../../_shared/ui/AdminButton";

export default function ProjetsHero({ stats, loading, onCreate }) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] border border-orange-100 bg-gradient-to-br from-orange-700 via-amber-600 to-sky-600 p-5 text-white shadow-xl shadow-orange-500/20 dark:border-orange-500/20 sm:p-7 lg:p-8">
      <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-white/15 blur-3xl" />
      <div className="pointer-events-none absolute bottom-[-80px] left-[30%] h-56 w-56 rounded-full bg-yellow-200/20 blur-3xl" />

      <div className="relative grid gap-6 lg:grid-cols-[1fr_auto] lg:items-end">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-white/90 backdrop-blur">
            <GiLargePaintBrush />
            Grands projets
          </div>

          <h1 className="mt-5 max-w-3xl text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
            Mettez en valeur les projets structurants de la commune.
          </h1>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-white/85 sm:text-base">
            Présentez les travaux, aménagements, équipements ou projets majeurs
            portés par la municipalité, avec une image, un descriptif et un lien
            vers une page de détail.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <div className="rounded-2xl border border-white/20 bg-white/10 px-4 py-3 backdrop-blur">
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-white/70">
                <FiTrendingUp />
                Total
              </div>

              <p className="mt-1 text-2xl font-bold">
                {loading ? "…" : stats.total}
              </p>
            </div>

            <div className="rounded-2xl border border-white/20 bg-white/10 px-4 py-3 backdrop-blur">
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-white/70">
                <GiLargePaintBrush />
                Publiés
              </div>

              <p className="mt-1 text-2xl font-bold">
                {loading ? "…" : stats.activeOnPage}
              </p>
            </div>

            <div className="rounded-2xl border border-white/20 bg-white/10 px-4 py-3 backdrop-blur">
              <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-white/70">
                <FiImage />
                Avec image
              </div>

              <p className="mt-1 text-2xl font-bold">
                {loading ? "…" : stats.withImageOnPage}
              </p>
            </div>
          </div>
        </div>

        <div className="flex lg:justify-end">
          <AdminButton
            icon={FiPlus}
            variant="white"
            size="lg"
            onClick={onCreate}
          >
            Nouveau projet
          </AdminButton>
        </div>
      </div>
    </section>
  );
}